import {
  ApolloClient,
  createHttpLink,
  from,
  InMemoryCache,
} from '@apollo/client';
import SessionService from './services/SessionService';
import { STORAGE_KEYS } from './shared/constants';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { TokenRefreshLink } from 'apollo-link-token-refresh';
import jwt_decode from 'jwt-decode';

const BASE_URL = process.env.REACT_APP_API_HOST;
const API_PATH = process.env.REACT_APP_API_PATH;

const COMPLETE_URL = BASE_URL + API_PATH;

// const COMPLETE_URL = 'https://dev.mpowered-health.com/graphql';

const logout = () => {
  SessionService.removeItem(STORAGE_KEYS.AUTH_TOKEN, 'session');
  SessionService.removeItem(STORAGE_KEYS.REFRESH_TOKEN, 'session');
  window.sessionStorage.removeItem("PATIENT_ID");
  client.clearStore();
  window.location.reload();
};

const httpLink = createHttpLink({
  uri: COMPLETE_URL,
});

const errorLink = onError(({ graphQLErrors }) => {
  if (graphQLErrors && graphQLErrors[0].message) {
    if (
      graphQLErrors[0].message.startsWith('401') ||
      graphQLErrors[0].message.includes('UNAUTHORIZED') ||
      graphQLErrors[0].message.includes('Not Authorized')
    ) {
      logout();
    }
  }
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists

  const token = SessionService.getItem(STORAGE_KEYS.AUTH_TOKEN);

  const realm = SessionService.getItem(STORAGE_KEYS.REALM_INFO);
  const patientId =  window.sessionStorage.getItem("PATIENT_ID") || '5120973';
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
      realm: realm ? realm : '',
      patientId: patientId,
    },
  };
});

//Non terminating link for token refresh.
const makeTokenRefreshLink = () => {
  return new TokenRefreshLink({
    isTokenValidOrUndefined: () => {
      const token = SessionService.getItem(STORAGE_KEYS.AUTH_TOKEN);
      if (!token) return true;
      const { exp: tokenExpiry } = jwt_decode(token);
      const currentNumericDate = Math.round(Date.now() / 1000);
      return currentNumericDate + 1 * 60 <= tokenExpiry;
    },
    fetchAccessToken: async () => {
      const refreshToken = SessionService.getItem(STORAGE_KEYS.REFRESH_TOKEN);
      const realm = SessionService.getItem(STORAGE_KEYS.REALM_INFO);
      const request = await fetch(COMPLETE_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          refresh_token: refreshToken,
          realm: realm,
        },
        body: JSON.stringify({
          query: `query getRefreshToken {
            getRefreshToken {
              access_token
              refresh_token
            }
          }
        `,
        }),
      });
      const result = await request.json();
      return result;
    },
    handleFetch: res => {
      console.log('Token fetched successfully');
    },
    handleResponse: (operation, accessTokenField) => response => {
      SessionService.setItem(
        STORAGE_KEYS.AUTH_TOKEN,
        response.data.getRefreshToken.access_token,
        'session'
      );
      SessionService.setItem(
        STORAGE_KEYS.REFRESH_TOKEN,
        response.data.getRefreshToken.refresh_token,
        'session'
      );
      return { access_token: response.data.getRefreshToken.access_token };
    },
    handleError: err => {
      console.warn('Your refresh token is invalid. Try to reauthenticate.');
      console.error(err);
      logout();
    },
  });
};

const tokenRefreshLink = makeTokenRefreshLink();

const client = new ApolloClient({
  link: from([tokenRefreshLink, errorLink, authLink, httpLink]),
  cache: new InMemoryCache({}),
});

export default client;
